module.exports = __webpack_public_path__ + "9701cd65ba71677ce875a3f5a4ed7d34.jpg";